/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_Edit_TitleInputs */

const cs_links_edit_title = /** @type {(inputs: Links_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upravit odkaz`)
};

const en_links_edit_title = /** @type {(inputs: Links_Edit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit link`)
};

/**
* | output |
* | --- |
* | "Edit link" |
*
* @param {Links_Edit_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_edit_title = /** @type {((inputs?: Links_Edit_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_Edit_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_edit_title(inputs)
	return cs_links_edit_title(inputs)
});